/**
 * @property {string} tplDir
 * @property {string} ajaxUrl
 * @property {string} heightEqualizationNeeded
 * @property {jQuery} $animElements
 */
var Thee = (function () {
    this.tplDir = "";
    this.ajaxUrl = "";
    this.heightEqualizationNeeded = "";
    this.$animElements = null;

    return this;
})();

(function ($) {
    var $window = $(window);
    var $document = $(document);
    var $body = $("body");

    // ANIMATED BACKGROUND IMAGE
    Thee.animateBackgroundImage = function ($obj, options) {
        if ($obj.length) {
            var xPos = (options.xPos === undefined) ? '50%' : options.xPos;
            var vPos = (options.vPos === undefined) ? 'bottom' : options.vPos;
            switch (vPos) {
                case 'top':
                    $obj.css({backgroundPosition: xPos + ' 0%'});
                    break;
                case 'bottom':
                    $obj.css({backgroundPosition: xPos + ' 100%'});
                    break;
            }
            var scrollTop = 0;
            var pos = $obj.offset();
            var hObj = $obj.outerHeight();
            var hWin = $window.height();
            $window.on("scroll", function () {
                scrollTop = $document.scrollTop();
                if (pos.top - scrollTop < hWin) {
                    switch (vPos) {
                        case 'top':
                            $obj.css({backgroundPosition: xPos + ' ' + ((scrollTop / (pos.top + hObj) * 100)) + '%'});
                            break;
                        case 'bottom':
                            $obj.css({backgroundPosition: xPos + ' ' + (100 - (scrollTop / (pos.top + hObj) * 100)) + '%'});
                            break;
                    }
                }
            });
        }
    };

    // PREPARATIONS
    // ==========================================================================================
    Thee.begin = function () {
        $('p:empty').remove();
        $('textarea').attr('rows', 8);
        $('.widget.widget_categories .widgetcontent > ul').addClass('sub-menu');
        $('.widget .sub-menu > li > a').prepend('<span class="triangle"></span>');

        $("ul.tabs").children().first().children("a").trigger("click");
    };

    // SCROLL ANIMATION
    Thee.checkIfInView = function () {
        var threshold = .1;
        var $items = Thee.$animElements;

        function checkWaypoints() {
            var wh = $(window).height();
            var scroll = $(window).scrollTop();
            $items.each(function (index, item) {
                var $item = $(item);
                var iThreshold = $item.attr("data-threshold");
                if (iThreshold !== undefined) {
                    threshold = parseFloat(iThreshold);
                }
                var iOffset = $item.position().top;
                var iHeight = $item.outerHeight();
                var iTop = iOffset - scroll;
                var iBottom = iTop + iHeight;
                var target = wh * threshold;
                if (iTop <= wh - target && iBottom >= target) {
                    if (!$item.hasClass("in-view")) {
                        $item.addClass("in-view");
                    }
                    $item.trigger("in-view");
                }
            });
        }

        $(window).on("scroll pseudo-scroll resize", function () {
            var to;
            to = window.setTimeout(function () {
                window.clearTimeout(to);
                checkWaypoints();
            }, 50);
        });

        checkWaypoints();
    };

    // CAROUSELS
    Thee.carousels = function () {
        $('.owl-carousel[data-auto-init]').each(function () {
            if ($(this).hasClass("gallery-slider")) {
                $(this).owlCarousel({
                    loop: true,
                    margin: 2,
                    dots: true,
                    responsive: {
                        0: {
                            items: 1
                        },
                        667: {
                            items: 2
                        },
                        1024: {
                            items: 3
                        },
                        1280: {
                            items: 4
                        }
                    }
                });
            } else {
                $(this).owlCarousel({
                    items: 1,
                    loop: true,
                    dots: true
                });
            }
        });
    };

    // COLUMNS
    // ==========================================================================================
    Thee.columns = function () {
        $('.cols').each(function () {
            if (!$(this).prev().hasClass('cols')) {
                $(this).addClass('cols-first');
            }
            if (!$(this).next().hasClass('cols')) {
                $(this).addClass('cols-last');
            }
        });
        $('.cols-last').each(function () {
            if (!$(this).next().hasClass('clearfix')) {
                $(this).after('<div class="clearfix"></div>');
            }
        });
        $('.cols-first').each(function () {
            $(this).nextUntil('.clearfix').andSelf().wrapAll('<div class="grid-collapse"></div>');
        });
    };

    /**
     * Can be used to assign as CSS classname to an HTML element with a delay
     * Use data-delayed-class="your-class-name" in conjunction with data-delay="{time}", where {time} is the
     * delay in milliseconds
     */
    Thee.delayedClassAssignment = function () {
        var $items = $("[data-delayed-class]");

        $items.each(function (index, item) {
            var $this = $(item);
            var $section = $this.parents("section");
            var cls = $this.attr("data-delayed-class");
            var delay = parseInt($this.attr("data-delay"));
            var isWaypoint = $section.hasClass("waypoint");

            if (!isWaypoint) {
                window.setTimeout(function () {
                    $this.addClass(cls);
                }, delay);
            }
            else {
                $section.on("in-view", function () {
                    window.setTimeout(function () {
                        $this.addClass(cls);
                    }, delay);
                });
            }

        });
    };


    Thee.equalizeHeights = function ($selector) {
        var top = Number.NEGATIVE_INFINITY;
        var lineIndex = -1;
        var lines = [];
        $selector.each(
            function (index, item) {
                var $item = $(item);
                var iTop = $item.offset().top;
                $item.css("height", "");
                if (iTop !== top) {
                    lineIndex++;
                    top = iTop;
                    lines[lineIndex] = [];
                }

                lines[lineIndex].push($item);

            }
        );

        for (var l in lines) {
            if (lines.hasOwnProperty(l)) {
                var max = 0;
                var line = lines[l];
                for (var i in line) {
                    if (line.hasOwnProperty(i)) {
                        var $item = line[i];
                        var h = $item.height();
                        if (h > max) {
                            max = h;
                        }
                    }
                }
                line.map(function ($item) {
                    $item.height(max);
                });
            }
        }

        $selector.trigger("height-equalized");
        return $selector;
    };

    // FORM
    // ==========================================================================================
    Thee.forms = function () {
        $('ul.gform_fields li.gfield .ginput_container').append('<div class="focus-border"></div>');
        $('ul.gform_fields li.gfield .ginput_container :input').focus(function () {
            $(this).next('.focus-border').addClass('focused');
        }).blur(function () {
            $(this).next('.focus-border').removeClass('focused');
        });
    };

    // INFINTE SCROLL
    // ==========================================================================================
    Thee.infiniteScroll = function () {
        $('.infinite-scroll').infiniteScroll({
            append: '.post',
            hideNav: '.iscroll-path',
            history: false,
            path: '.iscroll-path a'
        });
    };

    Thee.heroSlideshow = function () {
        var height;
        if ($window.width() >= 768) {
            height = Math.round(($(window).height() - $('#wpadminbar').height() - $('.the-header').height()) * 0.8);
            $('.hero-slideshow .slide').css({
                height: height
            });
            $('.hero-slideshow .slide .slide-image').css({
                height: '100%'
            });
        }
        else {
            height = Math.round($(window).width() * 1080 / 1920);
            $('.hero-slideshow .slide .slide-image').css({
                height: height
            });
        }

    };

    // MAP
    // ==========================================================================================
    Thee.map = function () {
        $('.the-map').click(function () {
            $(this).find('iframe').addClass('clicked');
        }).mouseleave(function () {
            $(this).find('iframe').removeClass('clicked')
        });
    };

    Thee.navigation = function () {
        $('body.error404 #header-menu > li[class*=current]').removeClass('current_page_parent');

        var $headerMenu = $("#header-menu");
        var $mobileMenu = $("#mobile-menu");
        var $headerMenuItems = $headerMenu.find("> li[class*=\"children\"]");
        var $mobileMenuItems = $mobileMenu.find("> li[class*=\"children\"]");
        var $headerMenuLinks = $headerMenuItems.find("> a");
        var $mobileMenuLinks = $mobileMenuItems.find("> a");
        $headerMenuLinks.append('<i class="fa fa-angle-down"></i>');
        $mobileMenuLinks.append('<i class="fa fa-angle-down"></i>');

        // MOBILE MENU
        $('.menu-toggle, .nav-mobile-fade-screen').on('click', function (e) {
            $('.menu-toggle').toggleClass('active');
            $('.nav-mobile, .nav-mobile-fade-screen').toggleClass('is-visible');
            e.preventDefault();
        });
        $mobileMenuLinks.click(function (e) {
            if (!$(this).next('ul').hasClass('visible')) {
                $mobileMenuItems.find("> ul").hide();
                $(this).next('ul').addClass('visible').slideDown();
                e.preventDefault();
            }
        });

        // DROPDOWN MENU
        $headerMenuItems.hoverIntent({
            timeout: 200,
            over: function () {
                //$(this).children("ul").slideDown();
	            $(this).children("ul").addClass('over');
            },
            out: function () {
                $(this).children('ul').removeClass('over');
            }
        });

        // PHONE NUMBER
        $('.the-header .phone-number').appendTo($headerMenu);
    };

    Thee.paralaxScrolling = function ($obj) {
        if ($obj.length > 0) {
            var dataEase = $obj.attr("data-ease");
            var ease = dataEase ? parseFloat(dataEase) : .5;
            var $container = $obj.parents(".scroll-container");
            var $spacer = $(".the-spacer");
            var abh = $("#wpadminbar").height();
            var margin = $spacer.is(":visible") ? $spacer.height() : 0;

            $window.on("scroll pseudo-scroll", function (e) {
                var matrix = [1, 0, 0, 1, 0, 0];
                var $win = $(e.currentTarget);
                var scrollTop = $win.scrollTop();
                var trans = $obj.css("transform");
                if (trans !== "none") {
                    var pattern = /matrix\(([^)]*)\)/;
                    var match = trans.match(pattern);
                    if (match[1]) {
                        matrix = match[1].split(", ");
                        for (var i = 0; i < matrix.length; i++) {
                            matrix[i] = parseFloat(matrix[i]);
                        }
                    }
                }

                if ($win.width() > 780) {
                    var goal = (scrollTop + abh + margin) * ease;
                    if ($container.length > 0) {
                        goal = ((scrollTop + abh + margin - $container.offset().top) * ease);
                    }

                    // don't let the element run out of its boundaries
                    if ((ease > 0 && goal < 0) || (ease < 0 && goal > 0)) {
                        goal = 0;
                    }

                    matrix[5] = goal;
                }
                else {
                    matrix[5] = 0;
                }
                var transform = "matrix(" + matrix.join(", ") + ")";

                $obj.css({
                    transform: transform
                });
            });
        }
    };

    Thee.resizeHandler = function () {
        if (Thee.heightEqualizationNeeded !== "") {
            Thee.equalizeHeights($(Thee.heightEqualizationNeeded));
        }

        // iframes in content
        var $iframe = $(".post-content iframe, .video iframe");
        if ($iframe.length > 0) {
            $iframe.each(
                function (index, item) {
                    var $item = $(item);
                    var w = parseInt($item.attr("width"));
                    var h = parseInt($item.attr("height"));
                    if (!isNaN(w) && !isNaN(h) && $item.css("display") === "block") {
                        var currW = $item.width();
                        if (currW !== w) {
                            var ar = w / h;
                            $item.height(currW / ar);
                        }
                        else {
                            $item.css("height", "");
                        }
                    }
                }
            )
        }
    };

    // STICKY HEADER
    Thee.stickyHeader = function (bInit) {
        var $header = $(".the-header");
        var $spacer = $(".the-spacer");
        var hHeader = $header.outerHeight();
        var scrollTop = 0;
        var lastScrollTop = 0;

        $spacer.height(hHeader);

        if (bInit) {
            $window.on("scroll pseudo-scroll", function () {
                scrollTop = $document.scrollTop();
                if (scrollTop < hHeader) {
                    $header.removeClass('pinned')
                        .removeClass('unpinned');
                    $body.removeClass("scrolled");
                    $header.trigger("unpinned");
                } else {
                    $header.removeClass('unpinned')
                        .addClass('pinned');
                    $body.addClass("scrolled");
                    $header.trigger("pinned");
                }
                lastScrollTop = scrollTop;
            });
        }

    };

    Thee.init = function () {
        Thee.$animElements = $('.animation_fadeup, .animation_fadedown, .animation_fadeleft, .animation_faderight, .waypoint');
        Thee.begin();
        Thee.columns();
        Thee.delayedClassAssignment();
        Thee.forms();
        Thee.infiniteScroll();
        Thee.map();
        Thee.navigation();
        Thee.stickyHeader(true);

        if (Thee.heightEqualizationNeeded !== "") {
            Thee.equalizeHeights($(Thee.heightEqualizationNeeded));
        }

    };

    Thee.onDocumentReady = function () {
        Thee.init();

        $window.trigger('pseudo-scroll');
    };

    Thee.onWindowLoad = function () {
        $('.animated-background-image').each(function () {
            Thee.animateBackgroundImage($(this), {
                vPos: 'top'
            });
        });

        $(".paralax").each(function (index, item) {
            Thee.paralaxScrolling($(item));
        });

        Thee.carousels();
        Thee.checkIfInView();
    };

    Thee.onWindowResize = function () {
        Thee.stickyHeader();
        if (Thee.heightEqualizationNeeded !== "") {
            Thee.equalizeHeights($(Thee.heightEqualizationNeeded));
        }
    };

    $document.on("ready", Thee.onDocumentReady);

    $window.on("load", Thee.onWindowLoad)
        .on("resize pseudo-resize", Thee.onWindowResize);


}(jQuery));

if (typeof theme !== "undefined") {
    Thee.tplDir = theme.tplDir;
    Thee.ajaxUrl = theme.ajaxUrl;
}